import { render, staticRenderFns } from "./ModalCompleteTransfer.vue?vue&type=template&id=2be0802a&scoped=true&"
import script from "./ModalCompleteTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalCompleteTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompleteTransfer.vue?vue&type=style&index=0&id=2be0802a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0802a",
  null
  
)

export default component.exports